// import React, { useState, useEffect } from "react";
// import "./Categories.css";
// import axiosConfig from "../../Service/axiosConfig";
// import { NavLink } from "react-router-dom";
// import Slider from "react-slick";
// const Categories = ({ data }) => {
//   const [loading, setLoading] = useState(false);
//   const [Data, SetData] = useState([]);

//   var settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 6,
//     slidesToScroll: 6,
//     responsive: [
//       {
//         breakpoint: 1400,
//         settings: {
//           slidesToShow: 5,
//           slidesToScroll: 5,
//         },
//       },
//       {
//         breakpoint: 1200,
//         settings: {
//           slidesToShow: 4,
//           slidesToScroll: 4,
//         },
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//         },
//       },
//       {
//         breakpoint: 766,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//     ],
//   };

//   return (
//     <>
//       <div className="categories-container">
//         {loading ? (
//           <div className="loader-container">
//             <img src={require("../images/loader.gif")} alt="Loading..." />
//           </div>
//         ) : (
//           <div className="container">
//             <h2 className="cat-section-title">Shop by category</h2>
//             <div
//               className={`${
//                 data?.length > 12 ? "cat-container" : "cat-container-6"
//               }`}
//             >
//               {data.map((itemObj, index) => {
//                 return (
//                   <div className="cat-item" key={index}>
//                     <NavLink to={itemObj.cat_slug ? itemObj.cat_slug : "#"}>
//                       <div className="cat-img">
//                         <img
//                           src={
//                             itemObj.image__image
//                               ? itemObj.image__image
//                               : itemObj.image
//                           }
//                           className="mx-auto image-fluid"
//                         />
//                       </div>
//                       <div className="cat-title">
//                         <p>{itemObj.name}</p>
//                       </div>
//                     </NavLink>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };
// export { Categories };
import React, { useState, useEffect } from "react";
import "./Categories.css";
import axiosConfig from "../../Service/axiosConfig";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";

const Categories = ({ data, onCategorySelect }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // const handleCategoryClick = async (itemObj) => {
  //   try {
  //     setLoading(true);
  //     const res = await axiosConfig.get(
  //       `/catlog/sub-categories/?category=${itemObj.id}&is_suspended=false&page_size=100`
  //     );
  //     console.table(res.data.results);
  //     const subcat = res.data.results[0];
  //     setLoading(false);

  //     // if (subcat) {
  //     //   // Navigate to first subcategory’s product page
  //     //   navigate(`/${itemObj.cat_slug}/${subcat.slug}`);
  //     // } else {
  //     //   // Fallback to category page if no subcategory exists
  //     //   navigate(`/${itemObj.cat_slug}`);
  //     // }
  //     if (subcat) {
  //       // FIX THIS LINE: use itemObj.slug not itemObj.cat_slug
  //       navigate(`/${itemObj.slug}/${subcat.slug}`);
  //     } else {
  //       // FIX THIS LINE: use itemObj.slug not itemObj.cat_slug
  //       navigate(`/${itemObj.slug}`);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching subcategories:", error);
  //     setLoading(false);
  //   }
  // };
  // const handleCategoryClick = async (itemObj) => {
  //   try {
  //     setLoading(true);

  //     // 🔥 Only call subcategory API for normal category
  //     if (itemObj.item_type === "category") {

  //       const res = await axiosConfig.get(
  //         `/catlog/sub-categories/?category&is_suspended=false&page_size=100`
  //       );

  //       const subcat = res.data.results[0];
  //       if (subcat) {
  //         navigate(`/${itemObj.slug}/${subcat.slug}`);
  //         // navigate(`/${itemObj.slug}/${subcat.slug}`, {
  //         //   state: itemObj.item_type === "promotional_category"
  //         //     ? { promotional_id: itemObj.id }
  //         //     : null
  //         // });
  //       } else {
  //         // navigate(`/${itemObj.slug}`, {
  //         //   state: itemObj.item_type === "promotional_category"
  //         //     ? { promotional_id: itemObj.id }
  //         //     : null
  //         // });
  //          navigate(`/${itemObj.slug}/${subcat.slug}`, );
  //       }

  //     } else {
  //       navigate(`/${itemObj.slug}`);
  //     }

  //     setLoading(false);

  //   } catch (error) {
  //     console.error(error);
  //     setLoading(false);
  //   }
  // };
 // In Categories.js - Updated handleCategoryClick function
const handleCategoryClick = async (itemObj) => {
  // Notify Navbar to show suggestions for this category
  if (onCategorySelect) {
    onCategorySelect(itemObj.id, itemObj.name);
  }
  try {
    setLoading(true);

    // Check if this is a promotional category
    if (itemObj.item_type === "promotional_category") {
      // Determine the category ID
      const catId = itemObj.linked_category_id || 
                    (Array.isArray(itemObj.category) ? itemObj.category?.[0]?.id : itemObj.category) || 
                    "";

      // Call subcategory API with category ID and promotional ID
      const res = await axiosConfig.get(
        `/catlog/sub-categories/?category=${catId}&promotional=${itemObj.id}&is_suspended=false&page_size=100`
      );

      const subcat = res.data.results[0];

      if (subcat) {
        navigate(`/${itemObj.slug}`, {
          state: {
            category_id: catId,
            subcategory_id: subcat.id,
            promo_id: itemObj.id,
            is_promotional: true
          }
        });
      } else {
        navigate(`/${itemObj.slug}`, {
          state: {
            category_id: catId,
            promo_id: itemObj.id,
            is_promotional: true
          }
        });
      }
    } else {
      // Normal category flow - fetch subcategories
      const res = await axiosConfig.get(
        `/catlog/sub-categories/?category=${itemObj.id}&is_suspended=false&page_size=100`
      );

      const subcat = res.data.results[0];

      if (subcat) {
        navigate(`/${itemObj.slug}/${subcat.slug}`, {
          state: {
            category_id: itemObj.id,
            subcategory_id: subcat.id
          }
        });
      } else {
        navigate(`/${itemObj.slug}`, {
          state: {
            category_id: itemObj.id
          }
        });
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 5, slidesToScroll: 5 } },
      { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 766, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    ],
  };

  return (
    <>
      <div className="categories-container">
        {loading ? (
          <div className="loader-container">
            <img src={require("../images/loader.gif")} alt="Loading..." />
          </div>
        ) : (
          <div className="container">
            <h2 className="cat-section-title">Shop by category</h2>
            <div
              className={`${data?.length > 12 ? "cat-container" : "cat-container-6"
                }`}
            >
              {data.map((itemObj, index) => (
                <div
                  className="cat-item"
                  key={index}
                  onClick={() => handleCategoryClick(itemObj)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="cat-img">
                    <img
                      src={itemObj.image}
                      alt={itemObj.name}
                      className="mx-auto image-fluid"
                    />
                  </div>
                  <div className="cat-title">
                    <p>{itemObj.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export { Categories };
